export default __webpack_public_path__ + "static/media/laconic_main_small.198ffb61.jpg";